var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 42.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-132);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-118);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-61);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-136);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-107);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-28);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-65);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-69);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-53);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-42);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-46);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-142);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#linear-gradient-70);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#linear-gradient-60);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#linear-gradient-93);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#linear-gradient-95);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#linear-gradient-100);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#linear-gradient-87);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#linear-gradient-64);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#linear-gradient-56);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#linear-gradient-43);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#linear-gradient-82);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#linear-gradient-138);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient-40);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#linear-gradient-27);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#linear-gradient-68);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#linear-gradient-37);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#linear-gradient-75);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#linear-gradient-55);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#linear-gradient-116);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#linear-gradient-39);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: url(#linear-gradient-89);\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: url(#linear-gradient-52);\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: url(#linear-gradient-113);\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: url(#linear-gradient-122);\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: url(#linear-gradient-58);\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: url(#linear-gradient-47);\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: url(#linear-gradient-26);\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: url(#linear-gradient-74);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: url(#linear-gradient-97);\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: url(#linear-gradient-72);\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: url(#linear-gradient-35);\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: url(#linear-gradient-30);\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: url(#linear-gradient-125);\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: url(#linear-gradient-76);\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: url(#linear-gradient-143);\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: url(#linear-gradient-109);\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: url(#linear-gradient-73);\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: url(#linear-gradient-71);\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: url(#linear-gradient-44);\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: url(#linear-gradient-144);\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: url(#linear-gradient-96);\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: url(#linear-gradient-49);\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: url(#linear-gradient-34);\r\n      }\r\n\r\n      .cls-63 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: url(#linear-gradient-38);\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: url(#linear-gradient-91);\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: url(#linear-gradient-133);\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: url(#linear-gradient-94);\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: url(#linear-gradient-54);\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: url(#linear-gradient-92);\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: url(#linear-gradient-90);\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: url(#linear-gradient-33);\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: url(#linear-gradient-79);\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: url(#linear-gradient-78);\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: url(#linear-gradient-51);\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: url(#linear-gradient-66);\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: url(#linear-gradient-57);\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: url(#linear-gradient-77);\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: url(#linear-gradient-131);\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: url(#linear-gradient-129);\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: url(#linear-gradient-103);\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: url(#linear-gradient-135);\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: url(#linear-gradient-121);\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: url(#linear-gradient-110);\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: url(#linear-gradient-88);\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: url(#linear-gradient-124);\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: url(#linear-gradient-128);\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: url(#linear-gradient-62);\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: url(#linear-gradient-29);\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: url(#linear-gradient-106);\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: url(#linear-gradient-67);\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: url(#linear-gradient-139);\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: url(#linear-gradient-141);\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: url(#linear-gradient-50);\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: url(#linear-gradient-134);\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: url(#linear-gradient-104);\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: url(#linear-gradient-59);\r\n      }\r\n\r\n      .cls-105 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: url(#linear-gradient-120);\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: url(#linear-gradient-108);\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: url(#linear-gradient-101);\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: url(#linear-gradient-80);\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: url(#linear-gradient-83);\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: url(#linear-gradient-112);\r\n      }\r\n\r\n      .cls-114 {\r\n        fill: url(#linear-gradient-105);\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: url(#linear-gradient-137);\r\n      }\r\n\r\n      .cls-116 {\r\n        fill: url(#linear-gradient-36);\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-118 {\r\n        fill: url(#linear-gradient-119);\r\n      }\r\n\r\n      .cls-119 {\r\n        fill: url(#linear-gradient-45);\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: url(#linear-gradient-127);\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: url(#linear-gradient-85);\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: url(#linear-gradient-98);\r\n      }\r\n\r\n      .cls-123 {\r\n        fill: url(#linear-gradient-81);\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: url(#linear-gradient-84);\r\n      }\r\n\r\n      .cls-125 {\r\n        fill: #d7063b;\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: url(#linear-gradient-114);\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: url(#linear-gradient-140);\r\n      }\r\n\r\n      .cls-128 {\r\n        fill: url(#linear-gradient-117);\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: url(#linear-gradient-48);\r\n      }\r\n\r\n      .cls-130 {\r\n        fill: url(#linear-gradient-102);\r\n      }\r\n\r\n      .cls-131 {\r\n        fill: url(#linear-gradient-32);\r\n      }\r\n\r\n      .cls-132 {\r\n        fill: url(#linear-gradient-86);\r\n      }\r\n\r\n      .cls-133 {\r\n        fill: url(#linear-gradient-41);\r\n      }\r\n\r\n      .cls-134 {\r\n        fill: url(#linear-gradient-130);\r\n      }\r\n\r\n      .cls-135 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-136 {\r\n        fill: url(#linear-gradient-111);\r\n      }\r\n\r\n      .cls-137 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-138 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-139 {\r\n        fill: url(#linear-gradient-31);\r\n      }\r\n\r\n      .cls-140 {\r\n        fill: url(#linear-gradient-63);\r\n      }\r\n\r\n      .cls-141 {\r\n        fill: url(#linear-gradient-115);\r\n      }\r\n\r\n      .cls-142 {\r\n        fill: url(#linear-gradient-126);\r\n      }\r\n\r\n      .cls-143 {\r\n        fill: #1d2088;\r\n      }\r\n\r\n      .cls-144 {\r\n        fill: url(#linear-gradient-99);\r\n      }\r\n\r\n      .cls-145 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-146 {\r\n        fill: url(#linear-gradient-123);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40.76,
    y1: 37.31,
    x2: 18.22,
    y2: 9.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007cc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1d2088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.85,
    y1: 43.75,
    x2: 10.43,
    y2: 16.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 42.61,
    y1: 35.84,
    x2: 20.19,
    y2: 8.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 28.48,
    y1: 47.29,
    x2: 6.06,
    y2: 19.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 39.55,
    y1: 38.32,
    x2: 17.13,
    y2: 10.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 42.05,
    y1: 36.29,
    x2: 19.62,
    y2: 8.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 44.14,
    y1: 34.6,
    x2: 21.72,
    y2: 6.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 39.37,
    y1: 38.48,
    x2: 16.92,
    y2: 10.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 39.24,
    y1: 38.58,
    x2: 16.8,
    y2: 10.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 39.66,
    y1: 38.18,
    x2: 17.31,
    y2: 10.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 39.08,
    y1: 38.76,
    x2: 16.55,
    y2: 10.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 39.61,
    y1: 38.16,
    x2: 17.34,
    y2: 10.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 38.8,
    y1: 38.94,
    x2: 16.35,
    y2: 11.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 38.97,
    y1: 38.72,
    x2: 16.66,
    y2: 11.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 38.6,
    y1: 39.11,
    x2: 16.14,
    y2: 11.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 39.11,
    y1: 38.71,
    x2: 16.64,
    y2: 11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 39.3,
    y1: 38.52,
    x2: 16.89,
    y2: 10.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 38.95,
    y1: 38.78,
    x2: 16.56,
    y2: 11.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 39.21,
    y1: 38.68,
    x2: 16.65,
    y2: 10.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 38.92,
    y1: 38.91,
    x2: 16.36,
    y2: 11.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 39.57,
    y1: 38.31,
    x2: 17.14,
    y2: 10.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 39.09,
    y1: 38.67,
    x2: 16.71,
    y2: 11.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 39.27,
    y1: 38.62,
    x2: 16.73,
    y2: 10.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 39.3,
    y1: 38.49,
    x2: 16.92,
    y2: 10.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 39.26,
    y1: 38.4,
    x2: 17.07,
    y2: 11.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 39.72,
    y1: 38.19,
    x2: 17.28,
    y2: 10.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 39.39,
    y1: 38.46,
    x2: 16.95,
    y2: 10.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 38.62,
    y1: 39.08,
    x2: 19.94,
    y2: 16.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 39.45,
    y1: 38.38,
    x2: 17.05,
    y2: 10.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 39.09,
    y1: 38.69,
    x2: 16.67,
    y2: 11.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 39.39,
    y1: 38.48,
    x2: 16.92,
    y2: 10.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 38.8,
    y1: 38.85,
    x2: 16.49,
    y2: 11.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 38.75,
    y1: 38.97,
    x2: 16.31,
    y2: 11.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 38.71,
    y1: 39,
    x2: 16.28,
    y2: 11.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 40.53,
    y1: 37.53,
    x2: 18.12,
    y2: 9.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 38.36,
    y1: 39.24,
    x2: 16,
    y2: 11.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 38.85,
    y1: 38.87,
    x2: 16.46,
    y2: 11.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 40.24,
    y1: 37.96,
    x2: 17.56,
    y2: 10,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 38.36,
    y1: 39.3,
    x2: 15.91,
    y2: 11.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 38.46,
    y1: 39.24,
    x2: 15.97,
    y2: 11.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 38.94,
    y1: 38.88,
    x2: 16.42,
    y2: 11.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 38.42,
    y1: 39.23,
    x2: 16,
    y2: 11.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 39.53,
    y1: 38.32,
    x2: 17.02,
    y2: 10.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 39.79,
    y1: 38.14,
    x2: 17.46,
    y2: 10.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 40.6,
    y1: 37.53,
    x2: 18.08,
    y2: 9.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 39,
    y1: 38.77,
    x2: 16.57,
    y2: 11.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 39.56,
    y1: 38.29,
    x2: 16.99,
    y2: 10.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 38.44,
    y1: 39.18,
    x2: 16.08,
    y2: 11.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 38.88,
    y1: 38.9,
    x2: 16.39,
    y2: 11.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 38.67,
    y1: 39.03,
    x2: 16.25,
    y2: 11.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 38.92,
    y1: 38.82,
    x2: 16.52,
    y2: 11.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 38.94,
    y1: 38.73,
    x2: 16.65,
    y2: 11.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 38.8,
    y1: 38.91,
    x2: 16.41,
    y2: 11.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 39.1,
    y1: 38.74,
    x2: 16.58,
    y2: 10.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 38.84,
    y1: 38.85,
    x2: 16.5,
    y2: 11.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 39.55,
    y1: 38.31,
    x2: 17.14,
    y2: 10.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 39.38,
    y1: 38.45,
    x2: 16.96,
    y2: 10.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 39.83,
    y1: 38.06,
    x2: 17.45,
    y2: 10.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 39.02,
    y1: 38.77,
    x2: 16.57,
    y2: 11.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 39.92,
    y1: 38.01,
    x2: 17.51,
    y2: 10.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 39.07,
    y1: 38.71,
    x2: 16.63,
    y2: 11.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 39.59,
    y1: 38.34,
    x2: 17.08,
    y2: 10.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 40.13,
    y1: 37.85,
    x2: 17.7,
    y2: 10.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 40.24,
    y1: 37.71,
    x2: 17.89,
    y2: 10.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 30.73,
    y1: 45.46,
    x2: 8.33,
    y2: 17.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 40.15,
    y1: 37.79,
    x2: 17.79,
    y2: 10.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 39.68,
    y1: 38.22,
    x2: 17.25,
    y2: 10.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 39.4,
    y1: 38.45,
    x2: 16.97,
    y2: 10.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 31.76,
    y1: 44.63,
    x2: 9.36,
    y2: 17.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 39.15,
    y1: 38.52,
    x2: 16.94,
    y2: 11.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 39.46,
    y1: 38.44,
    x2: 16.96,
    y2: 10.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 39.63,
    y1: 38.2,
    x2: 17.28,
    y2: 10.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 39.58,
    y1: 38.29,
    x2: 17.16,
    y2: 10.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 35.44,
    y1: 41.65,
    x2: 13.02,
    y2: 14.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 39.58,
    y1: 38.29,
    x2: 17.16,
    y2: 10.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 40.14,
    y1: 37.83,
    x2: 17.69,
    y2: 10.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 36.4,
    y1: 40.87,
    x2: 13.98,
    y2: 13.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 37.18,
    y1: 40.24,
    x2: 14.76,
    y2: 12.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 31.9,
    y1: 44.52,
    x2: 9.48,
    y2: 16.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 35.37,
    y1: 41.71,
    x2: 12.94,
    y2: 14.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 35.48,
    y1: 41.62,
    x2: 13.06,
    y2: 13.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 38.87,
    y1: 38.86,
    x2: 16.46,
    y2: 11.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 39.39,
    y1: 38.46,
    x2: 16.95,
    y2: 10.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 39.22,
    y1: 38.59,
    x2: 16.79,
    y2: 10.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 38.8,
    y1: 38.99,
    x2: 16.26,
    y2: 11.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 39.17,
    y1: 38.63,
    x2: 16.74,
    y2: 10.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 39.25,
    y1: 38.46,
    x2: 17,
    y2: 11.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 38.67,
    y1: 39.06,
    x2: 16.19,
    y2: 11.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 39.46,
    y1: 38.31,
    x2: 17.16,
    y2: 10.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 39.47,
    y1: 38.46,
    x2: 16.92,
    y2: 10.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 38.84,
    y1: 38.89,
    x2: 16.42,
    y2: 11.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 38.68,
    y1: 39.07,
    x2: 16.17,
    y2: 11.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 39.34,
    y1: 38.51,
    x2: 16.87,
    y2: 10.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 39.03,
    y1: 38.74,
    x2: 16.61,
    y2: 11.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 38.02,
    y1: 37.5,
    x2: 19.13,
    y2: 14.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 38.98,
    y1: 38.84,
    x2: 16.45,
    y2: 11.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 88.99,
    y1: 46.01,
    x2: 67.67,
    y2: 7.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 95.46,
    y1: 42.39,
    x2: 74.15,
    y2: 4.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 100.97,
    y1: 39.32,
    x2: 79.66,
    y2: 1.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 107.85,
    y1: 35.47,
    x2: 86.54,
    y2: -2.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 129.94,
    y1: 23.15,
    x2: 108.63,
    y2: -15.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 136.83,
    y1: 19.3,
    x2: 115.52,
    y2: -18.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 141.89,
    y1: 16.48,
    x2: 120.57,
    y2: -21.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 153.12,
    y1: 10.21,
    x2: 131.8,
    y2: -27.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 169.62,
    y1: 1,
    x2: 148.3,
    y2: -37.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 178.27,
    y1: -3.82,
    x2: 156.95,
    y2: -42.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 116.53,
    y1: 30.63,
    x2: 95.22,
    y2: -7.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 157.66,
    y1: 7.68,
    x2: 136.34,
    y2: -30.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 164.51,
    y1: 3.86,
    x2: 143.19,
    y2: -34.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 85.22,
    y1: 48.11,
    x2: 63.91,
    y2: 9.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 88.28,
    y1: 46.4,
    x2: 66.96,
    y2: 8.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 90.82,
    y1: 44.98,
    x2: 69.51,
    y2: 6.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 92.63,
    y1: 43.97,
    x2: 71.31,
    y2: 5.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 95.02,
    y1: 42.64,
    x2: 73.71,
    y2: 4.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 99.16,
    y1: 40.33,
    x2: 77.85,
    y2: 2.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 100.67,
    y1: 39.49,
    x2: 79.35,
    y2: 1.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 102.77,
    y1: 38.31,
    x2: 81.46,
    y2: 0.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 106.32,
    y1: 36.33,
    x2: 85,
    y2: -1.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 108.37,
    y1: 35.19,
    x2: 87.06,
    y2: -3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 109.9,
    y1: 34.33,
    x2: 88.59,
    y2: -3.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 111.63,
    y1: 33.37,
    x2: 90.31,
    y2: -4.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 113.43,
    y1: 32.36,
    x2: 92.11,
    y2: -5.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 116.26,
    y1: 30.78,
    x2: 94.95,
    y2: -7.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 119.18,
    y1: 29.15,
    x2: 97.87,
    y2: -9.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 121.55,
    y1: 27.83,
    x2: 100.24,
    y2: -10.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 124.11,
    y1: 26.4,
    x2: 102.8,
    y2: -11.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 127.38,
    y1: 24.58,
    x2: 106.06,
    y2: -13.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 129.67,
    y1: 23.3,
    x2: 108.35,
    y2: -14.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 132.22,
    y1: 21.88,
    x2: 110.91,
    y2: -16.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 135.39,
    y1: 20.11,
    x2: 114.08,
    y2: -18.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 137.87,
    y1: 18.72,
    x2: 116.55,
    y2: -19.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 140.05,
    y1: 17.51,
    x2: 118.73,
    y2: -20.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 144.66,
    y1: 14.94,
    x2: 123.34,
    y2: -23.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 147.17,
    y1: 13.54,
    x2: 125.85,
    y2: -24.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 150.17,
    y1: 11.85,
    x2: 128.86,
    y2: -26.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 153.74,
    y1: 9.86,
    x2: 132.43,
    y2: -28.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 157.38,
    y1: 7.83,
    x2: 136.07,
    y2: -30.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 160.39,
    y1: 6.15,
    x2: 139.08,
    y2: -32.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 162.19,
    y1: 5.14,
    x2: 140.88,
    y2: -33.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 165.03,
    y1: 3.57,
    x2: 143.71,
    y2: -34.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 167.95,
    y1: 1.94,
    x2: 146.63,
    y2: -36.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 170.52,
    y1: 0.5,
    x2: 149.2,
    y2: -37.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 173.26,
    y1: -1.03,
    x2: 151.94,
    y2: -39.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 174.66,
    y1: -1.82,
    x2: 153.34,
    y2: -40.01,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 66.36,
    y: 23.84,
    width: 0.22,
    height: 18.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "43.26 40.41 43.27 40.41 43.27 40.41 43.26 40.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M43.31,40.52c-.04-.1-.08-.2-.12-.29,0,0,0,0,0-.01-.05-.11-.1-.23-.16-.35,0,0,0,0,0,0-1.91-4.23-4.7-7.51-7.39-9.93-.07-.06-.14-.13-.21-.19-.13-.11-.25-.22-.38-.33-.4-.34-.81-.69-1.24-1.03h0c-.21-.16-.42-.31-.62-.47,0,0,0,0,0,0-.17-.13-.35-.26-.53-.39,0,0,0,0,0,0-.23-.17-.46-.33-.68-.48,0,0,0,0,0,0-.05-.03-.1-.07-.15-.1-2.43-1.65-4.21-2.43-4.21-2.43h0c-1.21-.59-2.51-1.14-3.9-1.63,0,0,.02.02.04.05-.04-.01-.08-.03-.12-.05,0,0,2.74,2.78,1.97,7.3.01.05.03.09.06.13-.37,2.05-1.4,3.97-2.64,5.63,0,0,0,0,0-.01-.02.03-.04.06-.07.08,0-.01,0-.02-.01-.03,0-.01,0-.03,0-.05-.56.74-1.22,1.51-2,2.3.06-.04.12-.08.19-.13.1-.07.13-.18.23-.23-.11.12-.22.24-.34.36.03-.02.07-.05.1-.07-.04.05-.09.09-.13.13,0-.01,0-.02,0-.04-.02.02-.05.05-.08.07,0-.02-.01-.05,0-.07-1.13,1.15-2.5,2.34-4.15,3.56h27.04s-.15-.49-.5-1.31c0,0,0,0,0,0ZM43.07,40.69s.03.01.04.02l.05.12h.02c.03.06.05.13.08.19-.14-.17-.33-.37-.47-.37,0,0,0,0-.01-.01h0s0,.01-.01.01v.03h.07c-.01.12.05.17.08.27.04.12.05.25.1.37.03.04.07.08.1.12.02.04.03.09.04.14h-.13s0-.01,0-.02c-.03-.12-.12-.23-.16-.35-.05-.14-.09-.29-.14-.43-.01-.02-.03-.13-.04-.13-.23-.09-.08.26-.07.35,0,.07-.03.11-.03.17-.02,0-.02,0-.02-.01-.05-.04-.07-.17-.07-.17-.04-.09-.08-.18-.07-.3h-.01c-.08-.04-.12-.09-.14-.17,0-.01-.01-.02,0-.02h0c.07.02.14.03.21.04.05,0,.1-.01.15-.02.06,0,.12,0,.18-.01.02-.01.14-.02.14-.03h.01s.02-.02.04-.04c.02.04.04.09.06.13v.02s0,.01-.02.02c-.02.03.01.07.04.09ZM42.22,41.47c-.06-.08-.16-.12-.18-.23-.01-.07.04-.11.04-.17.02-.1,0-.24-.04-.32-.04-.08-.17-.18-.17-.02-.02.02-.03.24-.03.28h-.01s-.02-.05-.02-.07h-.02c-.05.11-.06.22-.1.34-.03.09-.06.19-.09.29h-.07c.02-.09.05-.18.05-.28,0-.02-.02-.1,0-.1,0,0,0,0-.01-.01.03-.07.09-.14.09-.23h-.01s-.08.03-.13.03c0-.01-.02-.03,0-.03.06-.11.08-.22.13-.33h.01v-.03c-.17-.06-.31-.2-.48-.28-.14-.07-.38-.1-.55-.08-.07.01-.14.03-.21.04-.06,0-.12-.01-.14-.06-.01-.03-.03-.05-.04-.08,0-.04-.01-.08-.02-.12,0-.02-.04-.07-.02-.07.07-.04.16-.05.25-.05.07-.03.16-.07.24-.07.01,0,.03,0,.03-.02h.01c.05,0,.26.05.26.05,0,.01,0,.03.01.03h0s.03-.02.03-.04c.03-.01.15-.04.15-.07,0,0,0,0,.01.01.15-.05.31-.09.46-.14.08,0,.15,0,.23,0,.11,0,.23-.02.36-.02.02,0,.05,0,.07-.01.08,0,.15,0,.23.01.02,0,.05,0,.08-.01.03.07.07.14.1.22-.03,0-.06,0-.1-.01-.33-.04-.67-.04-.99,0-.06.02-.12.04-.17.05-.31.05-.6.13-.9.17-.08,0-.13-.04-.2-.04.02.09.11.14.19.14.08-.04.21-.05.31-.05.11-.03.52.1.61.15.04.04.07.07.11.11h0s-.05.04-.05.07h.06v-.02h.01c.09.03.28.1.37.1.09-.05.15-.01.24-.01h0c-.05.06.02.69.05.79.05.08.1.16.16.24,0,.02,0,.04,0,.07h-.16s-.02-.08-.04-.11ZM39.29,41.58c-.04-.05-.09-.09-.09-.17-.11-.09-.14-.28-.14-.43,0-.05.02-.1.02-.15-.02-.03-.03-.06-.05-.09-.04-.09-.07-.21-.1-.3-.03-.13,0-.24-.02-.36-.02-.06-.04-.12-.06-.17,0-.06,0-.12,0-.18,0-.06,0-.13.02-.18.02-.05.05-.1.07-.14h-.01c-.08-.07-.11-.33-.02-.33,0-.02,0-.07-.01-.07-.01-.05-.02-.16,0-.28-.08.01-.16.03-.23.05-.04.01-.07.04-.12.03-.06,0-.09-.05-.13-.08-.03-.02-.1-.02-.1.03.22.16.07.38,0,.57,0,.01-.02.07,0,.07.02.03.07.32.06.34-.03.05-.1.1-.1.16,0,.11.02.22.03.33,0,.06-.02.12-.02.18,0,.03,0,.12-.03.12h0s-.05,0-.07-.01c.02.07.05.13.06.22,0,.09-.03.19-.03.29,0,.06.01.13.02.19-.02.12-.08.22-.08.35,0,0,0,0,0,0h-.26s0-.09,0-.13c.02-.15.08-.28.08-.44,0-.12,0-.26-.02-.39,0-.04-.06-.09-.04-.14.01-.04.17.06.17.08.03-.05,0-.13.02-.19.01-.09.06-.17.06-.27,0-.12-.06-.2-.09-.31,0-.06,0-.11,0-.17-.02-.06-.06-.11-.07-.18,0-.05,0-.11,0-.16-.01-.05-.03-.1-.04-.15-.03-.15-.03-.31-.08-.45-.05-.06-.09-.12-.14-.18-.08-.13-.13-.33-.13-.49-.07-.03-.13-.07-.21-.09,0,.11,0,.2-.06.29-.04.06-.09.09-.09.17.2.05,0,.41,0,.52,0,0,.02,0,.02.01.13-.04.14.16.09.23-.02.04-.1,0-.1.01,0,0,0,0-.01-.01h-.01c.01.05.03.11.03.17,0,.08-.07.12-.09.2,0,.07,0,.14-.01.21-.02.07-.04.15-.07.22,0,.1-.02.19-.03.29,0,.06.02.12,0,.18-.02.04-.11.13-.15.13.01.02.04.07.07.07,0,0,0,0,0-.01.01,0,.05-.04.05-.02h.08s.13-.14.13-.09c0,0,0,0,.01,0v-.02c.01-.07.11-.34.21-.2,0,.02.01.03.02.05,0,.08-.01.17-.02.25.01.12.02.23.04.34,0,.12,0,.24,0,.36.01.09.07.14.09.21,0,.03,0,.06.01.09h-.94s-.06-.05-.08-.09c-.15-.27,0-.48-.35-.63-.02,0-.05,0-.07,0,0-.15-.04-.26-.06-.39,0-.06-.01-.12-.02-.18-.02-.04-.04-.07-.06-.1,0-.01,0-.04-.02-.04-.04-.04-.09-.23-.06-.23.02-.07,0-.21-.09-.21,0,0,0,0,.01-.01.05-.03.14-.06.16-.12,0-.01.02-.02,0-.02h0c-.15-.05-.1-.25-.15-.25-.05-.02-.11-.03-.16-.05-.05-.09.04-.21.04-.31-.02-.06-.05-.12-.07-.19.03-.05.05-.25.11-.25,0,0,0,0-.01-.01-.09-.07-.18-.05-.25-.1-.04-.03-.03-.11-.08-.14,0,0,0,0-.01,0,0,0,0,0,0,0-.07-.03-.31-.04-.35-.08-.05-.04-.03-.11-.03-.17h-.01c-.24-.21.09-.25.09-.4h.02s.18,0,.18-.07h.23s.17-.04.17-.06c0-.03,0-.14,0-.14,0-.06.01-.11.02-.17.02-.08.08-.14.1-.22.01-.08.03-.16.04-.24.03-.07.18-.18.25-.18v-.03s-.02-.05-.03-.08h.01c.07-.06.21-.13.17-.24,0,0,0,0,0-.01h.01s.05-.05.07-.07c-.03-.11.03-.29.13-.35.04-.01.09-.02.13-.04.03-.02.05-.05.08-.07.03-.02.07-.03.1-.05.02-.03,0-.07,0-.1.07-.04.42-.25.42-.32h.02s.04.02.06.02h0s0-.01.01-.01c.05-.18.27-.06.38-.16.21.03.15.07.18.24.02.03.03.06.05.1.04.09.05.17.18.17h0s.02-.01.02-.01c0,.12.03.22.04.32,0,.08-.05.15-.05.22-.02,0-.03,0-.05-.01,0,.04.06.09.06.11-.02.05,0,.14.06.14.04-.07.04-.15.07-.24.01-.02.02-.04.03-.06h.02s0,.01.01.01c-.01.07-.02.15-.04.22,0,.05.04.07.04.11h-.01s0-.01-.01-.01c-.06.01-.12.01-.18.01.02.1.1.16.21.12.03-.02.07-.03.1-.05v.03c-.06.05-.07.11-.09.18-.08.28.12.32.14.58.01.16-.07.26-.07.41-.06.07-.15.27-.05.34.05.02.1.04.15.06.1.08.16.16.29.16.12-.03.19.06.27.13.02-.02.05-.04.08-.04.05.04.16.12.21.05.01-.02.02-.04.03-.07.08,0,.15-.01.23-.02v-.02h-.01c-.07,0-.14,0-.21,0-.12,0-.24.07-.34-.02-.06-.06.09-.3.18-.3v-.05h.01s.07.07.11.07v-.02h.01c-.03-.06-.07-.09-.13-.11,0,0,0,0,0-.02h.01c.09-.09.22-.23.26-.35,0-.05.01-.09.02-.14.04-.1.11-.16.18-.24.16,0,.28.03.4.12.03.03.06.06.08.09.02.01.09.03.09.05h.01s-.05.13,0,.13c0,.02-.01.04-.02.06h.07s0,.08-.01.11c.03,0,.15.03.15.06-.03.08.03.13.05.21,0,.04,0,.08-.01.13.03.02.05.05.05.09.02,0,.09,0,.09.01h.01c.02.08.04.17.05.25.03.07.09.11.1.2,0,.08-.03.24-.03.34h.01s.09.01.14.01c.02.08.04.15.06.23-.02,0-.03,0-.05.01h0c.02.05.05.1.07.14.03.09.03.38-.07.41-.17.05-.28-.12-.43-.12,0,.02.02.1.03.1h0c-.1.02-.21.04-.31.05-.05,0-.11-.02-.16-.02-.02.06-.02.14,0,.2,0,.02.02.04.03.05,0,.02-.02.1-.03.1h0s-.08-.02-.11-.03c0,.12.02.18.15.18.01,0,.03-.02.03,0,.08.07.07.29.22.29.04-.06.09-.06.16-.07.08-.01.25,0,.3.06,0,.03.02.05.02.08.09.2-.03.23-.02.43,0,.18.07.33.07.52,0,.02-.01.04-.02.06h-1.52ZM37.56,39.27c0-.06,0-.11.01-.17.02,0,.02,0,.02-.01h.01c.12.15.1.32.15.52.03.07.06.14.08.21,0,.07-.01.14-.02.21h-.01s-.04-.03-.06-.04c-.01,0-.03-.02-.04-.03-.01,0-.03-.02-.04-.03-.02,0-.04-.02-.06-.02-.05,0-.09.01-.13,0-.09-.05,0-.32.03-.38,0,0,.01,0,.02,0,0-.04-.03-.23.02-.23ZM23.92,37.71s-.01-.01-.02-.02c-.07-.17.02-.36.02-.54-.04-.02-.07-.04-.11-.06-.06-.11-.13-.18-.17-.3,0,0-.02-.01-.03-.02-.25.08-.23-.18-.34-.18,0,0,.01-.01.02-.02.13-.24-.09-.2-.09-.27h-.02v-.02s0-.05-.01-.08l.07-.1s0,0,0,0c.01,0,.03-.01.04-.02,0,0,0-.01-.01-.02,1.24-1.67,2.07-3.33,2.49-4.95.03.05.08.09.17.13.07.03.15.06.22.08.01.14.02.29.04.43,0,.1-.07.16-.05.27.05.11.1.22.15.33.03.1-.03.16-.04.24-.02.17.13.39.31.39.06-.03.12-.06.18-.09v-.02s.02.01.04.02c.04.04.07.07.11.11.03,0,.11-.02.11-.05h.04c.13.15.22.28.22.51-.2-.01-.29.03-.44.11-.08.04-.17.09-.25.13-.11.11-.18.41-.19.57.01.05.02.11.04.16-.04.1-.08.19-.12.29-.06.23-.12.47-.18.7-.04.11-.09.21-.13.32,0,.11.02.21.03.32h-.04c-.03-.07-.07-.13-.15-.15-.02,0-.03-.02-.03,0h-.02s.01.09-.02.09c-.07.03-.13.04-.22.04,0,.05.02.18.09.18v.02c-.1.09-.21.11-.31.19-.07.05-.02.15-.06.21-.05.03-.11.06-.16.09-.09.05-.23.25-.23.36h.09s.04-.04.05-.05h.06s.01.06.02.09h-.02v.02c-.1.02-.44.34-.42.42.01.05.37.38.42.46.05.07.04.17.11.24.06.06.18.19.27.19v.02h-.02v.02c-.23-.05-.4-.17-.63-.22-.02,0-.04,0-.04-.03h.02c-.06-.16-.44-.35-.44-.07-.16.08-.31.22-.31.42-.12.13-.2.11-.38.11,0,0-.01-.01-.02-.02v-.02c.03-.06.07-.27.14-.27-.02-.1.06-.69.15-.69ZM22.35,39.66h-.02v-.02c-.07-.07-.14-.13-.22-.2.05-.22.08-.51-.22-.51-.02-.08-.05-.16-.07-.24.03-.03.1-.2.11-.2v-.02c-.07.01-.15.02-.22.04v-.07s.04-.06.05-.09c-.25-.02-.21.06-.32.21-.02,0-.04,0-.06.01-.08-.09.05-.19.05-.28-.02,0-.04-.01-.06-.02l.46-.48c.19-.04.38-.29.45-.47l.31-.32s.08.01.12.01c0,0,.01.01.02.02v.04h-.02v.02s-.13-.01-.13.02h-.02c.03.12.05.23.08.35.03.09.12.16.12.26h-.02s-.07.04-.11.05c.02.16.04.29.04.47,0,.02,0,.04.02.04.14.07.81.24.66.53-.02.03-.07.1-.11.1-.09-.09-.6-.31-.73-.31-.21.29-.16.66-.16,1.03ZM21.85,39.34c-.05.02-.1.04-.15.05-.02.04-.05.07-.07.11-.05.1-.12.02-.21.02,0-.04,0-.16.02-.16.1-.17.29-.31.43-.44h.02c-.03.06-.05.12-.08.18,0,.09.15.14.04.23ZM30.16,31.19s-.04,0-.06-.01c.01.05.03.1.04.14.04.04.09.07.13.11,0,.07.02.14.03.21.02.04.14.09.14.11v.09s.23-.02.23-.01h.01s0,.01-.01.01c-.17.18-.42-.04-.58.15-.03.05-.05.1-.08.15-.03.05-.06.1-.09.15-.02,0-.03,0-.03-.01-.08-.05-.08-.15-.08-.24-.21,0-.42,0-.62,0-.04-.02-.08-.04-.12-.07,0-.02,0-.03.01-.03h0s.19-.09.19-.13h.03c.36.19.26-.27.2-.47-.02-.05-.05-.1-.07-.15,0-.09-.01-.19-.02-.28,0-.02-.04-.07-.07-.07-.02,0-.42-.13-.42-.13.02,0,.03,0,.05-.01.06-.02.13-.07.2-.07.04,0,.09.01.13.02.02,0,.08-.04.08-.07h.03s.02.06.05.06c0,0,0,0,.01.01.03,0,.07-.02.1-.03.05-.04.1-.09.15-.13-.02-.06-.11-.29-.19-.29.04-.02.07-.05.11-.07.08-.06.12-.12.22-.16.13.09.15.48.22.53.07.05.18.02.27.02h0s.07.01.1.03c.04-.02.08-.03.12-.05.07.11.24.06.11.23-.04.05-.06.1-.12.13-.02,0-.09.04-.09.02-.33-.09-.29.05-.29.29ZM28.24,29.82c-.06.13.03.28.04.42,0,.02,0,.01-.01.01-.02,0-.03.02-.05.03-.21.13-.21-.38-.31-.49-.05-.05-.1-.03-.17-.04-.07-.02-.14-.03-.21,0-.03.02-.16.05-.16.09-.09-.04-.12.02-.21.02-.04,0-.09-.02-.13-.02.07-.06.26-.16.26-.27.05-.03.14-.11.14-.18-.09-.11.1-.7-.17-.7,0-.13.06-.26.05-.38-.02-.06-.05-.12-.07-.18,0-.02,0-.07-.02-.07h0c-.07,0-.28.13-.28-.04.06-.03.13-.05.19-.08.07,0,.14.01.22.02.06-.01.11-.03.17-.04.09-.04.2-.03.29-.09.12-.08-.12-.39-.12-.52h.28s.05,0,.07.02c.21.1-.18.43.37.43.03,0,.05-.02.08-.03h0s.43.07.43,0c.12.08.08.18.08.31,0,0,0,0-.01-.01h-.01s-.05-.05-.07-.08c-.08-.03-.36-.02-.39.06-.04.1.08.18.08.27h-.01s-.03.02-.05.03c.02.15.1.1.22.1h0s0,.01.01.01c-.06.18-.12.37-.18.55-.01.1.06.18.06.27-.09.13.15.28.26.28.03,0,.05,0,.08-.01,0,.19-.16.11-.28.1-.02,0-.05-.01-.05.01h-.01v.08c-.06,0-.12.01-.18.02-.07,0-.24-.1-.23.07,0,.02,0,.04.02.04ZM27.37,36.03s.06.03.09.04c0-.02.02-.11,0-.11v-.02s.09-.07.09-.07c0-.03-.04-.08-.04-.08.02-.02.05-.05.08-.05.05-.03.12-.14.12-.2-.02-.02-.05-.05-.05-.08.02-.01.03-.03.05-.04,0-.04.02-.09.02-.13.02,0,.05,0,.06,0,0-.01,0-.06-.02-.06v-.02s.03-.02.04-.04c.01,0,.02,0,.03,0h0s.02-.02.04-.03c.02,0,.07,0,.07.02.06.13.1.05.2.13.03.03.05.06.08.09.05.06.12.09.17.16,0,0,0,0,.01,0,0,.07.05.15.07.22,0,.04,0,.08,0,.12.02.05.04.1.06.15,0,.04-.01.08,0,.12.02.04.06.06.1.06,0,.07.03.15.11.15.03,0,.05-.01.08-.02.02.03.05.08.1.08h0s0-.02,0-.02c0-.02,0-.11.02-.11.01.06.11.4-.07.27,0,0-.02-.01-.02-.02-.03,0-.06.03-.09.02-.04-.01-.06-.09-.09-.12-.03-.03-.11-.04-.15-.04-.02.06-.04.22,0,.27,0,0,.01.01,0,.01-.01.03-.03.1-.08.1-.03.1-.02.13.05.2.01.01.03.04.05.04h0s-.03,0-.05,0c-.03.05-.06.19.05.19v.02s-.04.04-.04.07c-.07.02-.15.07-.22.02-.02-.02-.04-.05-.07-.05,0-.04,0-.07-.02-.1-.04-.04-.08-.04-.13-.06-.08-.04-.16-.09-.24-.13-.02-.02-.04-.04-.06-.05-.04-.01-.07.01-.1.01h0c-.05-.07-.05-.3-.11-.3,0-.01,0-.02,0-.02.01-.02.02-.03.03-.05h0v-.07h-.05s0-.01,0-.02c.01-.02.02-.07-.02-.07h0s0-.01,0-.01c.01-.07-.11-.12-.17-.1-.04.01-.05.05-.09.06-.05,0-.09,0-.14-.01-.07,0-.05-.09-.1-.11-.04-.02-.09.01-.13.01h0s0-.01,0-.01c.03-.04.19-.2.23-.2h0s0,0,0,0h0c.06-.02.16-.07.22-.04ZM28.48,40.11s-.02-.07,0-.07c0-.03.02-.06.03-.1.04.02.08.05.12.07.02.05.03.09.05.14.04.08.31.33.1.36-.05-.01-.1-.02-.16-.03-.18-.07-.14-.2-.14-.37ZM26.05,41.21c-.05-.2-.29-.19-.37-.34-.09.09-.29.13-.43.1-.1-.02-.17-.12-.17-.12.14,0,.25-.06.33-.16.05.01.1.03.16.04.03.02.06.05.09.07,0-.06.08-.21.11-.21,0-.01-.02-.03,0-.03.01,0,.03-.02.03,0,.04.01.11.07.15.05.04-.02,0-.21.07-.21-.03-.14.01-.31.09-.41.03-.04.09-.06.1-.11.02-.07,0-.13,0-.2h.01c.11-.02.17-.11.17-.21.02,0,.02,0,.02-.01,0-.04.01-.23.06-.23-.02-.33.41-.39.41-.49.02-.11.05-.21.12-.29.03-.02.06-.05.09-.07.06-.08.1-.17.17-.25.04,0,.07.01.11.02,0,.02-.02.12.01.12,0,0,.01.01.01,0h.02s.02-.07.03-.1h.01c.06.06.15.15.15.25.05-.01.1-.03.15-.04.03,0,.21.27.23.31.01.05.03.1.04.14.05.08.11.14.15.22.02.06,0,.14.02.2.03.06.05.12.08.18.03.12,0,.23,0,.36,0,.03,0,.11-.03.11v.02c.3.09-.17.71.39.71.06-.03.21-.07.21.04h.01c.12-.02.17.2.17.29h-.01c-.11.03-.19.03-.3.02-.02,0-.03,0-.03,0-.14.14-.41-.12-.41.02.03.02.06.04.09.06-.02.1.01.17.01.26h-.02c-.1-.11-.21-.12-.33-.18-.14-.07-.27-.15-.41-.24-.01,0-.07-.05-.05-.05.09-.11.18-.12.32-.12v.02c.06.08.13.1.24.1.07-.03.14-.01.19-.09.05-.08-.11-.48-.18-.53-.1-.04-.2-.07-.3-.11-.02,0-.11-.04-.11,0,0,.06.08.09.08.13h.01s.02-.09.06-.09c.03.07,0,.12,0,.19-.01-.01-.02-.02-.03-.03h0s-.01-.01-.02-.01c-.01.03-.03.08-.07.08h0s-.13-.28-.04-.28v-.02c-.08-.02-.15-.08-.24-.08h0s0,.01.01.01c0,.01.03.04.01.04-.03.05-.1.16-.17.16-.04-.08-.09-.2-.07-.31.01-.05.02-.09.04-.14-.19-.01-.24-.11-.39-.15-.07-.02-.14.01-.2.01h0s0,.01.01.01h0c.22.05.04.28-.01.39-.03.07-.07.15-.1.22-.04.05-.07.09-.11.14,0,0,0,0-.01.01.12.05.35.35.45.09.01-.03.01-.11.06-.1.1.06.04.22.17.27.02,0,.03,0,.05.01.01-.06.05-.16.12-.16.04.06.09.26-.01.3,0,0,0,0,0,0-.01,0-.03,0-.04,0-.13-.03-.27-.07-.4-.1-.05,0-.1,0-.15,0-.1,0-.2-.01-.3-.02-.15,0-.21.1-.38.08h-.01s-.01.03-.02.04h.01s.07.02.11.03c.23-.25,1.18.08,1.43.21.03.02.12.09.12.09.1.03.19.07.29.1.1.06.18.15.3.16.06,0,.08-.04.12-.04,0-.02-.03-.06-.01-.06h0c.07,0,.13.03.19.03v.02h-.01s-.12.02-.12.07c.03.02.06.04.09.06,0,0,0,0-.01.01-.02.03-.02.06-.01.09h-2.49s0,0,0,0c0-.11.05-.25.03-.37ZM31.73,41.41c-.1-.24.13-.38.3-.45.22-.09.42-.19.56-.39.06-.09.15-.16.07-.27-.09-.11-.14.04-.2.06-.02,0-.04.03-.05.02-.27-.17-.54.02-.8.02-.07,0-.17.02-.19-.07-.03-.1.05-.15.13-.19.32-.15.47-.46.66-.73.01-.02.02-.04.02-.05-.11-.34.19-.55.26-.84.04-.15,0-.19-.13-.18-.07,0-.13.02-.19.01-.13-.02-.2-.14-.25-.25-.05-.1.07-.16.13-.22.25-.23.55-.26.87-.2.08.02.18.06.21-.06.04-.14.15-.27.09-.42-.03-.06-.14-.13-.18-.09-.22.25-.56.08-.81.26-.12.09-.29.27-.45.14-.16-.13.04-.31.05-.46.02-.2.2-.18.35-.24.3-.13.58-.16.91-.15.33,0,.47-.35.33-.66-.04-.09-.08-.17-.06-.27,0-.06,0-.13-.06-.14-.2-.02-.32-.12-.42-.28-.05-.08-.11,0-.16.03-.13.1-.25.07-.36-.01-.32-.26-.73-.31-1.1-.45-.11-.04-.22-.03-.31.07,0,.35-.26.55-.47.79,0,.02,0,.04-.01.05-.01.02-.02.04-.03.06,0,.16,0,.32-.02.48,0,.07-.04.16-.13.16-.09,0-.09-.08-.1-.14-.05-.33-.21-.6-.41-.85-.11-.13-.13-.29-.12-.45,0-.14-.03-.2-.2-.16-.24.05-.44-.17-.69-.16-.02,0-.05-.04-.05-.06.02-.55-.48-.33-.73-.48-.09-.06-.24-.02-.36-.04-.18-.02-.22-.04-.37-.18.18-.09.35-.04.52,0,.21.04.39.04.6-.03.26-.1.54-.07.82.02.36.12.75.16,1.12.23.13.02.24-.02.31-.14.04-.07.1-.11.18-.12.17-.03.21-.14.21-.3.01-.52.61-.99,1.16-.86.08.02.12.07.13.16.02.36-.03.69-.32.94-.02.02-.04.06-.06.08.4.15.81.13,1.2.22.1.02.22.01.23-.13.01-.16.22-.16.24-.28.02-.15-.23-.04-.24-.2,0-.04-.02-.07-.02-.11-.03-.16-.31-.25-.2-.43.17-.28.36-.56.65-.73.04-.03.11-.04.16-.03.52.05.88.61.74,1.1-.04.13-.11.18-.22.23-.16.07-.21.19-.12.34.09.15.03.25-.06.37-.13.19-.24.4.02.58.07.05.08.13.1.2.08.23.09.47.21.69.12.22-.01.41-.2.56-.14.11-.26.22-.21.45.12.5.67-.05.84.32.24.56-.6.58-.91.5-.1-.03-.13.04-.1.11.09.2.04.38,0,.57-.05.17.07.32.09.5.04.42.13.83-.02,1.25-.03.08-.02.17.07.22.05.03.09.06.08.13-.03.14-.59.46-.71.38-.14-.09-.2-.02-.3.07-.31.26-.52.61-.91.79-.03.01-.05.02-.08.03h-.41s-.06-.09-.09-.17ZM42.54,39.42c-.08,0-.17-.02-.23-.04-.03-.02-.07-.04-.1-.06h0s0-.01.01-.01c0-.01.13-.2.13-.2h0s.04.04.07.05c.04.08.08.17.12.25ZM42.01,39.5h-.02s-.08.03-.08.01c-.1-.07-.15-.18-.3-.18,0,0,0,0-.01-.01,0,0,0,0,.01-.01.08-.1.16-.21.24-.31.07.07.04.2.06.3.03.07.07.14.1.21ZM41.38,39.48c-.18.27-.25-.03-.28-.18-.02-.08-.06-.11-.06-.21.15.07.3.22.35.38,0,.01,0,.01,0,.01ZM36.88,33.85c0,.11,0,.23,0,.34.01.09.03.19.04.28.01.03.03.05.04.08-.01.03-.02.06-.04.09-.18-.05-.15-.17-.16-.33,0-.12-.05-.22,0-.34,0-.02.04-.07.02-.07-.03-.08-.08-.21-.18-.2-.04,0-.07.02-.1.02h0c-.11-.17-.12.08-.12.15.18.02.18.29.15.44-.01.06-.06.12-.05.18,0,.07.13.13.13.19-.02.01-.08.03-.08.06-.08-.03-.11-.07-.15-.15-.02-.03-.04-.06-.06-.1-.04-.15.1-.28.06-.39-.03-.03-.06-.07-.09-.1-.07-.11-.1-.29-.24-.36-.06,0-.12,0-.18-.01-.02-.01-.04-.03-.05-.04,0-.03.1-.05.12-.05.28-.19.33-.36.28-.73-.01-.06-.03-.12-.05-.18.01-.05.06-.07.1-.09.16.12.31.24.47.36,0,.15.08.27.2.34.05.05.1.09.14.14h0s-.31.13-.32.16c-.06.11.09.19.11.29ZM33.65,28.6l.03.02s-.05.04-.05.07c.01,0,.02,0,.03,0,0,0,0,0,0,0h0s-.04.07-.03.13c0,0,0,.01,0,.01-.01.02-.02.03-.03.05,0,.04-.02.07-.02.11-.01.05-.05.1-.05.15.03,0,.08,0,.08.03.01,0,.03,0,.04,0,.01,0,.02.01.03.02,0,0,.06,0,.06.01.03.04.03.04.07.02,0,0,0,0,0,0,.02.01.03.03.04.05,0,.02.02.1.05.1h0s0,0,0,0c-.01,0-.03.01-.04.02-.03,0-.19-.02-.19-.05h-.06s-.07-.03-.1-.04c-.01,0-.02-.02-.04-.01-.04.01-.08.06-.14.04-.02,0-.02-.03-.06-.04,0,0-.05-.03-.04-.03,0-.02.02-.05.02-.07.07-.03.12-.07.12-.16-.04-.03-.03-.05-.05-.08-.02-.03-.04-.05-.06-.08,0-.02-.02-.03-.03-.05-.03-.04-.08-.04-.11-.07,0-.01-.02-.02-.02-.04-.02-.03-.06-.05-.07-.09,0-.04-.02-.07-.02-.11-.01-.03-.05-.04-.07-.06-.02-.02,0-.05,0-.08,0-.02-.02-.03-.02-.05,0-.07.05-.11.08-.16.01-.02.01-.05.01-.08h.02c.2.17.41.32.62.49ZM32.55,27.77s0,0,0,.01c0,.04,0,.08.01.11,0,.06-.04.11-.02.18.01.04.07.02.09.05.02.03.02.08.03.12.02.03.03.06.05.1.02.05.03.12.03.17,0,.09-.06.14-.05.22,0,.04.04.08.08.08.04-.03.04,0,.06.03.01.02.02.03.04.05.03.07.03.16.02.24,0,.03-.02.06-.02.09.02,0,.06-.04.07-.04h0s.01.1.02.15c0,.02.03.03.04.04.03.04.06.09.06.14,0,.04,0,.07,0,.1-.01.06-.05.11-.05.18,0,0,.02.02.02.03.03,0,.06,0,.1,0h0s0,.05,0,.08c-.01.04-.04.08-.04.13,0,.04.04.05.05.08.02.09.02.17.03.26,0,.02.02.03.02.05.05-.03.09-.06.14-.09.02,0,.03,0,.05.01.03-.01.05-.01.09-.01.1-.04.12-.05.23-.02.05.01.07.02.1.06,0,.01.02.03.03.04-.02.06-.14.13-.21.13h0s0,0,0-.01c.01-.02.05-.09.02-.1-.02,0-.06-.01-.06.01,0,.02.03.03.03.04,0,0,.01,0,.02,0,0,0,0,0,0,0-.04.05-.14.04-.2.04,0,.01,0,.02,0,.03.07.02.09,0,.15,0,0,0,0,0,0,0h0s-.06.05-.09.07c-.07.02-.13.04-.2.06-.03.01-.06.03-.1.04-.02,0-.07-.01-.09,0-.03.03,0,.14-.01.18-.03.11-.12.06-.1.21,0,0,0,0,0,0,.11.08.02.11-.03.17-.02.03-.03.06-.04.09,0,.02-.02.03-.02.05-.01,0-.02,0-.03,0-.03.05-.07.09-.11.13-.01.02-.03.04-.04.05-.04.04-.09.07-.13.11-.05.05-.02.1-.05.13-.02.02-.05.03-.07.03-.02,0-.06.02-.08.03-.07,0-.26-.07-.31-.1-.05-.03-.08-.1-.08-.16,0,0,0-.02,0-.02,0,0,0,0,0,0-.04-.04-.08-.07-.08-.13,0,0,0-.01,0-.01,0,0,0-.01,0-.01-.02-.02-.04-.03-.06-.05.01-.05-.01-.07-.03-.11-.01-.05-.01-.1-.04-.14-.04-.05-.09-.11-.13-.17-.02-.03-.01-.07-.04-.09-.05-.06-.11-.1-.16-.15-.03-.03-.03-.07-.06-.09-.02-.01-.05-.02-.08-.02-.08-.02-.18-.04-.25-.08-.03-.02-.05-.04-.09-.03,0,0,0,0,0,0-.02-.01-.03-.04-.03-.06.01-.03,0-.07.03-.09,0,0,0,0,0,0h0s.02,0,.04,0c.02-.04.05-.02.09-.02.07,0,.1-.03.16.02.03.02.05.05.08.06.06.02.16,0,.2.05,0,0,.01.02.02.03.13-.03-.07-.15-.08-.17,0-.02.06.02.06,0,.01-.02-.01-.08.03-.08,0-.05.01-.09.02-.14,0-.02,0-.05-.01-.07.01-.02,0-.05,0-.08,0-.04.05-.12.1-.12,0-.02,0-.07.04-.07,0-.03.01-.05.01-.08-.02,0-.04,0-.06,0v.06s-.08,0-.12,0c0,0,0,0,0,0,.02-.03.05-.05.09-.05,0,0,0,0,0,0h0s0-.1.05-.1c0-.02,0-.03,0-.05.05-.06,0-.08.03-.13.01-.03.03-.05.04-.08,0-.1.1-.19.03-.29,0,0-.02-.02,0-.02.02-.08.06-.08.09-.14.03-.06,0-.14.06-.19,0,0,0,0,0,0,0,0,0,0,0,0h0s-.01-.03-.02-.04c.01,0,.02,0,.03,0-.02-.07.01-.09,0-.15,0,0,0,0,0,0h0s.03-.02.05-.03c0-.01,0-.05,0-.05.05-.07.07-.03.07-.13.05-.03.04-.09.06-.13.01-.03.1-.14.14-.14,0-.07.06-.11.06-.18.02-.02.03-.04.07-.04,0,0,0-.03.01-.03h0s-.03-.07-.06-.07c0,0,0,0,0,0,0,.01-.01.07-.02.07h0s0,0-.01,0c0-.05,0-.09.01-.14h0c.06.04.12.08.18.13l.03.02ZM32.02,27.39s-.04,0-.05.01c0,0-.03.01-.03,0-.03-.03-.06-.03-.1-.05-.03-.02-.05-.04-.08-.05-.03,0-.07,0-.1,0-.03,0-.07-.01-.11-.02-.01,0-.05,0-.05,0,0,0,.02-.01.02-.02-.02,0-.11,0-.11,0,0-.02,0-.04,0-.05.04-.06.16-.03.21-.06.02.01.04.02.05.04,0,0,.02.01.02.02l.13.09c.06.04.12.09.18.13ZM23.1,41.58c-.13-.11-.29-.2-.42-.2v.16s.07-.03.07,0c.02,0,.04.02.07.04h-.32c-.06-.18-.44-.27-.61-.26-.15,0-.26.09-.42.09-.11-.02-.23-.04-.34-.06,0,.04.03.16.07.16v.04s-.09,0-.12.04h-.49s-.02-.04-.03-.05c-.08-.07-.17-.14-.25-.21-.04-.07,0-.14,0-.21-.09-.03-.41-.06-.42-.19.02-.02.04-.04.06-.05.05,0,.1,0,.15-.01.13-.04.19-.18.35-.18.06,0,.12-.01.18-.02.02,0,.05-.03.05,0,0,0,.01-.01.02-.02.04-.01.08-.02.13-.04.05.02.15.1.15.16h.05c.09-.14.38-.2.54-.2.02-.02.11-.06.11-.04.13.04.26,0,.4,0,.1-.06.24-.04.35-.1.12-.06.39-.51.47-.63.08.01.16.11.24.11.04.4.44.26.49.6,0,.05-.01.1-.02.14-.1.03-.21.06-.31.09-.07-.02-.15-.05-.22-.07-.19-.04-.37.1-.4.27,0,.04.02.08.03.11.03.02.06.05.09.07.2.1.43.23.52.45h-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M28.58,15.31c0-1.44-1.17-2.61-2.62-2.61s-2.61,1.17-2.61,2.61,1.17,2.61,2.61,2.61,2.62-1.17,2.62-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M11.41,41.83c27.43-19.93-2.06-24.23-2.06-24.23,24.3,6.87,2.06,24.23,2.06,24.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M4.48,37.48C-1.59,26.11,8.82,10.99,27.74,3.72c.77-.29,1.53-.57,2.3-.83C34.81,1.28,39.63.33,44.24,0c-4.67,0-9.6.6-14.56,1.86-.46.12-.91.24-1.37.37C8.6,7.76-3.64,21.86.97,33.71c1.26,3.24,3.65,5.97,6.86,8.13h.04c-1.39-1.29-2.54-2.74-3.4-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M33.25,20.24c-12.32-2.6-23.41-3.32-23.41-3.32,19.45,2.74,30.44,10.44,35.31,5.63,3.9-3.85-10.69-7.24-10.69-7.24,8.22,2.19,11.34,7.58-1.22,4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M29.55,24.69s12.14,5.49,20,17.15h7.02s-13.57-13.62-27.02-17.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M32.16,29.55s.01.07.01.1c.01-.04.01-.07-.01-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M32.16,29.98s0,0,0,0h0c0-.1.05-.19,0-.28,0,.09,0,.18,0,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M32.14,28.98s.02-.1.01-.15c-.03.04-.03.1-.03.15h.01s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M32.24,30.29s.01.06.01.09c.01-.03.01-.07-.01-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M32.1,28.89s0,.01,0,.01h0s0,0,.02,0c0,0,0,0-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.17,30.62c-.01.1.02.21.02.32,0,0,0,0,.01,0,0-.07,0-.28-.03-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M32.24,30.39s0,.04,0,.04c0-.01,0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.2,31.33c0-.09,0-.19-.03-.26,0,.03-.02.15,0,.15,0,0,0,.02,0,.02,0,.02,0,.09.02.09h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M32.18,30.24s0,0,0,0c0,0,0,0,0,0,0-.05.01-.1,0-.15,0,.05-.02.1-.02.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M32.12,29.69s-.03-.11-.07-.13h0s.06.13.06.13h0s0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M32.17,30.54s0,.02,0,.02c0-.08.04-.21,0-.28,0,.09,0,.17,0,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M32.17,30s0,.01.01.02h0s0-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M32.18,30.61s0-.03,0-.05c0,0-.01.04,0,.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M32.12,29.25h0c.02-.05.03-.13.02-.18-.01-.03-.02-.05-.03-.08,0,0,0-.03,0-.03h-.01s0,0,0,0c0,.04,0,.3.03.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M31.9,30.05h0c.04-.06-.03-.2-.03-.27,0-.06.05-.09.06-.14,0-.02,0-.03,0-.04-.02.07-.08.12-.09.19,0,.04,0,.08,0,.12h0s.05.12.05.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M31.86,29.59s.07-.11.06-.13c-.02.04-.07.07-.07.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M31.94,29.42h0s0-.02-.01-.02c0,0,0,.02,0,.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M32.08,29.55v-.02s-.01.03,0,.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M33.02,29.89s-.02.09,0,.09c0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M31.99,29.23s-.06.1-.06.16c.01-.03.08-.13.06-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "32.5 31.54 32.5 31.54 32.51 31.54 32.5 31.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M31.97,29.23s.04-.07.04-.11c-.02.03-.06.07-.06.11,0,0,.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M32.03,30.24c0,.07.06.13.06.21,0,0,0,0,.01,0,0-.09,0-.14-.03-.22,0,0-.01-.02,0-.02,0,0,.03,0,.03-.01,0,0,0,0,.01,0h0s.01.03.02.05h0v-.08c-.13-.02-.03-.12-.02-.19,0-.04-.05-.06-.04-.11,0-.07.05-.11.06-.17-.03.07-.08.11-.08.2,0,0,0,0,0,0,0,0,0,0,0,0,.01.02.02.05.03.07,0,.04-.03.07-.04.11,0,.05,0,.1-.01.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M32.09,29.52c-.02-.06.03-.05.03-.09,0,0,0,0,0,0,0-.01-.02-.03-.03-.04,0,.03,0,.1-.04.1h0s.04.02.04.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M32.04,30.54s.01,0,.01,0h0s0,0,.01,0c0,0,0-.02,0-.03,0,0-.01.01-.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M32.07,30.61s.04.2.04.26c0,0,0,.04,0,.04,0,.02,0,.04.01.05.01.02.02.04.03.07h0s-.01-.07-.02-.11c0-.04.02-.09,0-.14,0-.04-.03-.07-.04-.1,0-.02,0-.06-.01-.08-.02-.02-.05-.03-.08-.04,0,0,0,.03,0,.03.02,0,.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M31.89,30.4c-.01-.09.05-.25,0-.32,0,0,0,0-.01-.01,0,0,0,0-.01,0,0,.04,0,.08,0,.12h0s0-.03,0-.04h0c0,.07.01.11.02.17,0,.05,0,.1,0,.15,0,.04.02.08.03.12,0,.04,0,.08,0,.12,0,.03.05.07.05.09h0c0-.06-.03-.1-.03-.17,0,0,0,0,0,0h0s0-.01,0-.01c.04.17.08.35.1.54,0,.01,0,.06,0,.06,0,.01.01.02.02.03h.01s0-.1.02-.1h0c.02.06,0,.11.01.16.01.05.02.09.04.14h0s0-.09-.01-.13c0-.05,0-.1,0-.14,0-.03-.04-.08-.04-.09,0,0,0,0,0-.01-.04-.05-.04-.14-.04-.21-.02-.07-.03-.13-.05-.2-.02-.08-.09-.15-.1-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M42.28,39.65h-.06s.06,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M31.31,30.58s.01.03.02.03h0s.01,0,.01-.01c0,0,.01,0,.01,0,0,0,.04.02.04,0,0-.02-.07-.03-.08-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M32.24,30.86s0-.02,0-.03c0-.08.04-.18-.01-.24,0,.04.01.08.02.12,0,.05-.03.1,0,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M31.48,27.17s.01.04.04.04h0s0,0,0,0c0-.02-.02-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M31.35,30.52s-.04-.03-.06-.03c-.06.01-.11.01-.17.01h0s0,.01,0,.01c0,0,.04.03.04.03.03-.01.06-.02.1-.02.02,0,.08.03.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M31.48,30.62s0,0,0,0h0s0,0,0,0c0,0,.01,0,.02.01,0,0,0,0,0,0h0s0,0,0,0h0s-.02-.02-.02-.03c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M31.68,29.93s0,.02,0,.02h0s.02,0,.03,0c0-.02,0-.02-.02-.04,0,0-.01,0-.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M31.51,30.75s0,.03,0,.03c.02,0,.12.06.12.09.04-.08-.06-.11-.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M40.81,39.86h-.06s.06,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M41.69,40.5h0s0-.01.01-.01v-.03h-.06s.02.05.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M33.2,28.39h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.82,30.86s-.05.08-.08.12c-.01.05-.02.09-.03.14-.02.06-.06.11-.08.18,0,.01,0,.02,0,.03.04.04-.12.28-.16.32,0,0-.14.09-.14.09-.04-.02-.09-.05-.13-.07-.03-.02-.08-.07-.09-.1,0,0,0,0,0,0,.02,0,.04.02.05.02.01.01.03.03.04.04.04.02.07.01.1.04,0,0,.01.02.01,0,.02,0,.04,0,.06,0h0s.12-.1.12-.13h0s-.02.02-.03.04h0s0-.03,0-.05c-.04,0-.07.02-.1.02,0-.07.05-.1.06-.17,0-.03,0-.07,0-.11,0-.04.02-.08.03-.12.03-.12.08-.22.08-.35,0,0,0,0,0,0,0,0,0,0,0,0,.06-.04.11-.23.11-.3h-.02s-.02.07-.03.1c-.02.05-.07.13-.07.19h0s0-.03,0-.04h-.02s-.02.06-.02.09c-.02.06-.03.12-.05.18,0,.05-.01.09-.02.13-.01.03-.02.06-.03.09,0,.04,0,.08-.02.12-.02.03-.03.07-.05.1,0,.03,0,.08-.02.1-.02.02-.06,0-.09,0,0-.02,0-.09-.03-.09h0s.01-.09.01-.13c0-.02.01-.03.02-.05,0-.04,0-.08.01-.12,0-.04-.01-.07-.02-.1,0,0,0-.02,0-.03,0-.02,0-.04,0-.06h0s0,.03-.01.04c0,0,0,0,0,0,0,0,0,0-.01-.01-.02.04.09.3-.02.3h0c0,.05.01.1.02.14-.02,0-.04-.02-.06-.03,0,.01.04.07.02.07-.02,0-.04-.01-.05-.03-.09-.1-.1-.26-.14-.39-.02-.04-.03-.07-.05-.11,0-.03,0-.05-.01-.08-.01-.03-.02-.05-.03-.08,0-.03-.02-.06-.03-.09-.02-.06-.06-.1-.07-.16,0-.04,0-.09,0-.13,0-.04-.02-.08-.03-.13,0-.03,0-.05,0-.08,0-.02,0-.03-.01-.05,0,0,0,0,0,0-.01.03,0,.08,0,.11,0,.08-.02.15-.02.23h.01s.01-.12.02-.12h0c.01.05,0,.26.04.26,0,0,0,0,0,.01h0s-.04-.08-.06-.12h0s.02.1.03.15c.02.04.03.07.05.11.03.1.04.21.07.31.03.11.07.2.11.3.01.03.02.07.03.1.02.03.06.05.09.08.01.02.03.04.04.06.03.01.05.02.08.04.03.01.07.05.1.05.02,0,.12-.03.13-.05.01-.03.03-.06.04-.09.02-.03.04-.05.07-.08.04-.06.06-.13.09-.2.02-.03.04-.07.06-.1.02-.06.03-.12.05-.18.01-.03.03-.06.04-.08.01-.03.02-.06.03-.08.02-.03.03-.05.05-.08.02-.04.02-.08.03-.12.02-.05.05-.09.07-.14.01-.04.02-.09.03-.13,0-.05,0-.09,0-.14.01-.02.02-.04.03-.06,0-.02,0-.04,0-.06-.01-.02-.02-.05-.03-.07,0-.04,0-.08,0-.11-.07.11.02.1,0,.18,0,.04-.02.09-.03.13-.01.03-.04.06-.05.09,0,.03,0,.06,0,.09-.01.03-.02.06-.03.1,0,.03,0,.05,0,.07-.02.02-.03.05-.05.07-.01.04-.03.07-.04.11ZM31.85,30.88c-.02-.06-.04-.11-.06-.17.08.08.09.21.12.32.02.04.04.08.06.13-.02,0-.03,0-.04-.02-.05-.07-.05-.17-.07-.25ZM32.07,31.53s-.02,0-.02,0c0-.04-.02-.07-.03-.11-.02-.03-.04-.06-.06-.09-.01-.04-.02-.08-.03-.12,0,0,.04,0,.04.02,0,.02,0,.04,0,.05.01.03.16.23.1.26ZM32.64,31.32s0,0,0-.02c0,0,0,0,0,0,0,0,0,.02-.01.02ZM32.66,31.29h0s0-.01,0-.01c.01-.03.03-.07.05-.1,0,.04-.05.08-.05.11ZM32.98,30.39s-.02.23-.03.23c0,0,0,0,0,0h0c.01-.08.03-.16.04-.24ZM32.74,31.1h0c0-.09.05-.16.1-.23-.03.07-.06.15-.09.23ZM32.85,30.87s0,0,0,0c0,0,0,0,0,0h0s.02-.08.05-.12c.02.07-.03.08-.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M40.87,39.94h0s.02-.04.02-.06h-.06s0,.04.01.06h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M31.55,30.61s-.03.05-.03.09c.03-.01.06-.06.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M32.36,30.83s0,.09.01.09c0-.03,0-.06-.01-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M32.29,31.46h.01s.01-.06.01-.1c.02-.02.04-.05.04-.08,0-.04.02-.3,0-.32,0,.04-.01.07-.02.11,0,.06,0,.12,0,.18,0,.04-.03.07-.04.11,0,.03,0,.06,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M32.35,30.7s0,.04,0,.05h0s0-.04-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M32.37,30.54s-.01.05-.02.08c0,.02,0,.05,0,.07h0c0-.05.03-.1,0-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32.3,31.12s0,0,0,0c0,0,0-.01,0-.02.04-.07,0-.15.01-.23,0-.07.02-.13,0-.2,0,.08-.02.16-.02.25,0,.07,0,.13,0,.2h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M32.38,30.52h0s.02-.09,0-.13c0,.02-.02.13,0,.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M32.43,30.99h0s.02-.05.02-.08c0,.01-.03.09-.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M32.37,29.55s.06-.24.02-.28c0,.02-.01.04-.02.07,0,.03.02.05.01.08,0,.03-.02.05-.03.08,0,.04,0,.09,0,.13,0,0,0,.01,0,.02,0-.03.02-.06.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M32.35,30.37s0,0,0,0h0s0,0,0,0c0-.02.05-.04.05-.06-.04-.09.02-.16.03-.23,0-.03,0-.06,0-.09,0-.04.02-.06.02-.11,0-.04-.02-.08-.01-.13,0-.13.08-.25.06-.38-.01.04-.01.08-.03.13,0,.02-.02.04-.02.06,0,.04-.01.08-.02.11,0,.03-.01.05-.02.08,0,.05,0,.1.02.14-.01.04-.02.08-.03.12,0,0-.04,0-.04-.01-.03-.06,0-.15,0-.22,0-.02-.01-.05-.02-.07,0,0,0,0,0,0,0,.07,0,.15,0,.22,0,.08-.05.23-.03.31,0,.04.03.08.04.12ZM32.36,30.05c.08.05,0,.15,0,.22h0s0,0,0,0h0c0-.08.01-.14.02-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M32.38,28.98h0c0-.07,0-.14,0-.2,0,.03-.02.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M32.33,30.41c0,.06-.01.12-.02.18h0s0,0,.01,0c0,0,0,0,0,0,.01-.05.01-.12,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M32.38,28.76h0s.03-.08-.01-.11c0,.04,0,.08,0,.12,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.46,30.86s.07-.51.06-.54c-.03.07-.05.17-.06.25,0,.03,0,.06,0,.09,0,.04,0,.08-.01.13v.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M32.9,30.04s-.04.1-.01.1c0-.03.03-.07.01-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M32.56,28.5s.03.05.03.08c0,.03-.02.05,0,.08.01.01.02.03.04.04,0,0,0,0,0,0,0-.04.02-.07.01-.11,0-.02-.08-.17-.09-.18,0,.03,0,.06,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M32.52,28.18v.02s-.04.02-.04.04c0,0,0,0,.02,0,0,0,0,0,0,0,.02-.01.05-.03.07-.05,0,0,0-.01,0-.01-.04,0-.08-.02-.11-.03,0,.01.01.02.02.03.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.22,40.63s.16-.05.16-.06h.01c-.08-.31,0-.24.11-.47.02-.08.05-.17.07-.25.04-.07.12-.13.12-.22-.05-.01-.1-.02-.16-.03-.03.05-.06.1-.09.15-.03.03-.06.06-.09.09-.06.11-.07.26-.11.38-.04.12-.08.24-.12.35,0,.01,0,.04.01.04.03,0,.05,0,.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M32.51,28.33s-.06-.04-.07-.05c0,.01-.01.02-.02.03h0s.07.04.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M32.61,28.98c0,.06-.02.12-.02.19.02.06.04.12.04.2,0,.04-.01.08-.02.13,0,.02,0,.05,0,.07,0,.08,0,.16,0,.25h0c.07,0,0,.2,0,.24h0s.01.02.02.03h0s0,0,0,0c0,0,0,0,.01,0,0,0,0,0,0,0,.05-.03.08-.07.08-.13,0,0,0,0,0,0-.01.03-.04.11-.08.11h0c-.01-.05,0-.1,0-.15,0-.03,0-.07-.01-.1,0-.04,0-.07,0-.11,0-.08-.05-.23.01-.3,0,0,0,0,.01,0v-.02s-.02,0-.03,0c.01-.06.01-.09-.01-.14,0-.02-.02-.03-.03-.05-.01-.06.02-.11-.01-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M32.74,30.29c0-.08.03-.19-.02-.26,0,.04,0,.07,0,.11,0,.02-.01.04-.02.07,0,.05,0,.11,0,.15,0,0,0,.01,0,.02h0s0-.04.01-.05c0,.03.01.06.02.09h0c0-.06.01-.11.02-.17,0,0,0,0,0,0,0,.02-.01.03-.02.05,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26.9,39.36c.05-.09.12-.11.2-.17.06-.05.3-.36.32-.43,0-.06,0-.12,0-.18,0-.09-.01-.15-.08-.21-.02.01-.04.03-.06.04,0,.04,0,.09.01.13,0,.08-.02.16-.05.22-.04.06-.08.13-.12.2-.06.05-.12.11-.18.16-.04.04-.03.09-.05.14-.01.02-.08.09-.07.09.03.01.05.02.08.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M32.76,30.68h0s0,0,0,0c0-.02,0-.04.01-.06,0,0-.03.07-.02.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M32.78,30.16s0,.06,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M32.72,29.78h0s.04-.11.02-.16c-.01.02-.04.15-.02.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M32.74,29.89h0s-.02-.05-.03-.08c0,.03.02.05.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M32.8,39.75c.15-.02.31-.04.41-.19.22-.35.55-.67.42-1.15-.02-.06.03-.14.06-.21.04-.12.03-.23-.09-.29-.13-.07-.23-.01-.31.1-.12.18-.13.38-.17.59-.07.36-.1.74-.41,1-.03.03-.08.06-.05.12.02.05.08.04.14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M39.29,37.94s.09.09.09.12v.03s.06,0,.06.02c0,.04.07.1.1.1h0c-.08-.11-.13-.21-.25-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M42.41,40.62s-.03-.03-.04-.04c0,.02.02.05.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M32.21,34.51c-.51-.1-1.01-.31-1.54-.07-.05.02-.14-.01-.17.07-.03.07.03.13.07.17.16.13.12.26-.01.37-.19.17-.29.38-.3.63.03,0,.1,0,.1,0,.09-.28.35-.46.47-.72-.04-.16.02-.27.16-.34.18-.08.38-.14.56,0,.13.1.26.13.42.12.33-.01.67-.06,1,.03.11.03.23,0,.33-.1-.07-.09-.16-.06-.24-.08-.28-.08-.57-.02-.84-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M31.41,33.68c.1-.17.23-.28.42-.34.1-.03.13-.15.14-.31-.28.17-.64.16-.72.54-.01.06-.03.11.02.15.06.05.11,0,.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M27.11,39.38s.08.04.11.07c.06.01.12.02.18.03.06.03.1.08.15.12.13.1.26.14.34.3.01.02.04.09.06.09h0s0,.01.01.01c-.08-.4-.11-.82-.23-1.19,0-.07-.01-.13-.02-.2-.04-.08-.11-.12-.18-.17.12.3-.06.62-.28.83-.03.03-.14.06-.14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M29.91,34.48c0-.05-.02-.1-.08-.07-.11.06-.14-.03-.2-.09-.12-.12-.29-.16-.45-.2-.13-.04-.17.09-.19.19-.02.08.04.13.12.11.19-.06.31.02.43.17.07.08.18.09.29.06.07-.02.07-.1.09-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M30.17,34.61c-.06-.01-.38.29-.36.34.07.13,0,.38.2.37.23-.01.29-.23.3-.44-.01-.11,0-.24-.15-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M32.65,30.86c-.02.06-.04.12-.06.18-.04.07-.08.14-.12.21,0,0-.02.05,0,.05h0c.05-.06.22-.38.19-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M32.54,30.24s.03-.09.04-.14c0-.05,0-.1,0-.15,0-.03.04-.06.02-.1-.02.05-.05.11-.05.16,0,.02,0,.05.01.07,0,.06-.02.1-.02.16,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M32.58,30.46s-.01.06-.02.09c0,.05,0,.11,0,.16,0,0,0,0,0,0h0c.02-.11.03-.23.04-.35.02-.06.03-.12.05-.19,0-.02,0-.05-.01-.07,0,.04,0,.08,0,.11-.01.04-.03.08-.04.12,0,.04,0,.07,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M32.59,31.26s-.05.1-.03.1c.01-.03.03-.06.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M32.67,30.82h0s.04-.06.04-.1c0-.03,0-.07,0-.1.01-.04.02-.07.04-.11h0c-.05.08-.07.2-.08.3,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M32.75,30.41s-.04.06-.04.06h0s.02-.04.03-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M32.54,31.46s.02-.06,0-.06c0,0-.01,0-.02,0-.03.04-.05.06-.07.1,0,0,0,0,0,0h0s0,0,0,0c.02-.03.04-.03.08-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M32.79,30.14s.03-.08,0-.11c0,.02-.03.11,0,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M32.87,30.24s-.02.08-.04.13h0s.04-.08.03-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M32.6,31.25s.02-.06,0-.1c0,0-.03.1,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M32.54,31.51h0s0-.02,0-.03c0,.01,0,.02,0,.03h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M32.81,30.57s.07-.13.03-.18c-.01.06-.02.11-.03.17,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M32.63,31.13s.03-.06.04-.09c.05-.14.12-.16.08-.34-.02.06-.02.12-.04.18-.03.07-.06.13-.08.2,0,0-.01.05,0,.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "32.59 30.8 32.59 30.8 32.59 30.8 32.59 30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M32.53,31.06s0,0,0,0c0-.09.06-.17.05-.27-.04.04-.06.19-.06.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M126.76,26.8c-1.1-.72-2.57-.42-3.3.68-.01.02-.02.04-.04.06-.72,1.1-2.2,1.41-3.3.68-1.08-.71-1.4-2.15-.72-3.24-1.4,2.19-.78,5.11,1.4,6.54,2.2,1.44,5.15.83,6.59-1.37,0,0,.01-.02.02-.03.03-.05.07-.11.1-.16.61-1.08.29-2.47-.76-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M126.04,23.57c-2.16-1.42-5.06-.85-6.52,1.27-.02.03-.05.07-.07.1-.01.02-.02.03-.03.05-.68,1.09-.37,2.53.72,3.24,1.1.72,2.57.41,3.3-.68.01-.02.02-.04.04-.06.72-1.1,2.2-1.4,3.3-.68,1.05.69,1.38,2.08.76,3.16,1.29-2.17.65-5-1.49-6.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M82.89,32.25h-7.05v-1.58l3.47-3.3c.35-.34.59-.63.71-.87.12-.25.18-.48.18-.71,0-.33-.11-.58-.33-.76-.22-.17-.55-.26-.98-.26-.36,0-.69.08-.99.23-.3.15-.56.37-.77.67l-1.74-1.12c.37-.56.87-1,1.52-1.33.65-.32,1.38-.49,2.21-.49.69,0,1.3.11,1.83.34.53.23.94.55,1.23.98.29.43.43.93.43,1.5,0,.51-.1.99-.31,1.44-.21.45-.62.95-1.22,1.52l-1.87,1.78h3.68v1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M85.13,31.86c-.6-.38-1.08-.93-1.42-1.66-.34-.73-.52-1.6-.52-2.62s.17-1.89.52-2.62c.35-.73.82-1.28,1.42-1.66.6-.38,1.29-.57,2.06-.57s1.46.19,2.06.57c.61.38,1.08.93,1.42,1.66.34.73.51,1.6.51,2.62s-.17,1.89-.51,2.62c-.34.73-.81,1.28-1.42,1.66-.61.38-1.3.57-2.06.57s-1.45-.19-2.06-.57ZM88.36,29.7c.28-.44.42-1.15.42-2.12s-.14-1.68-.42-2.12c-.28-.45-.67-.67-1.17-.67s-.87.22-1.15.67c-.28.45-.41,1.15-.41,2.12s.14,1.68.41,2.12c.28.45.66.67,1.15.67s.89-.22,1.17-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M98.61,32.25h-7.05v-1.58l3.47-3.3c.35-.34.58-.63.71-.87.12-.25.18-.48.18-.71,0-.33-.11-.58-.33-.76-.22-.17-.55-.26-.98-.26-.36,0-.69.08-.99.23-.3.15-.56.37-.77.67l-1.74-1.12c.37-.56.87-1,1.52-1.33.65-.32,1.38-.49,2.21-.49.69,0,1.3.11,1.83.34.53.23.94.55,1.22.98.29.43.43.93.43,1.5,0,.51-.11.99-.31,1.44-.21.45-.62.95-1.22,1.52l-1.87,1.78h3.68v1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M105.24,26.69c.49.24.87.59,1.15,1.04.28.45.43.96.43,1.54,0,.63-.16,1.19-.47,1.67-.31.48-.74.85-1.28,1.11-.54.26-1.14.39-1.81.39-1.29,0-2.31-.4-3.05-1.2-.74-.8-1.11-1.94-1.11-3.43,0-1.06.2-1.97.6-2.74.4-.77.96-1.35,1.68-1.74.72-.4,1.55-.59,2.5-.59.51,0,.99.06,1.46.17.47.12.86.28,1.19.49l-.88,1.79c-.46-.32-1.03-.48-1.7-.48-.58,0-1.07.14-1.47.41-.4.27-.69.67-.85,1.18-.03.09-.07.3-.13.64.57-.41,1.28-.61,2.15-.61.59,0,1.12.12,1.6.37ZM104.1,30.29c.25-.22.38-.53.38-.91s-.13-.69-.38-.91c-.25-.22-.59-.33-1-.33s-.75.12-1.01.35c-.26.23-.39.53-.39.9s.13.67.38.9c.25.23.6.34,1.04.34.4,0,.73-.11.98-.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M135.16,29.29c.54-.28.95-.67,1.25-1.18.3-.51.45-1.11.45-1.79s-.15-1.32-.46-1.84c-.31-.52-.74-.92-1.3-1.2-.56-.28-1.22-.42-1.98-.42h-3.79v9.41h2.22v-2.54h1.57-.05s.65,1.06.65,1.06l.92,1.48h2.38l-.87-1.4-.98-1.58ZM132.97,27.79h-1.43v-2.94h1.43c.54,0,.94.13,1.22.38.28.26.41.62.41,1.09s-.14.82-.41,1.08c-.28.26-.68.39-1.22.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "140.37 28.45 144.21 28.45 144.21 26.54 140.37 26.54 140.37 24.82 144.71 24.82 144.71 22.86 138.17 22.86 138.17 30.87 138.17 32.27 144.87 32.27 144.87 30.5 144.87 30.3 140.37 30.3 140.37 28.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M151.05,22.86h-2.2l-3.02,7.54-.75,1.87h2.27l.69-1.9h3.75l.69,1.9h2.32l-1.23-3.07-2.54-6.34ZM149.93,25.25l1.17,3.27h-2.35l1.18-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M163.8,27.19v.81c0,.82-.14,1.41-.43,1.79-.29.38-.72.56-1.28.56s-.99-.19-1.28-.56c-.29-.38-.44-.97-.44-1.79v-5.15h-2.22v5.24s0,.08,0,.12c.02,1.33.36,2.36,1.03,3.09.69.75,1.65,1.13,2.89,1.13s2.21-.38,2.9-1.13c.69-.75,1.03-1.82,1.03-3.21v-5.24h-2.2v4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M187.42,22.86h-2.2l-1.31,3.27-2.46,6.14h2.27l.69-1.9h3.75l.69,1.9h2.32l-2.28-5.7-1.49-3.71ZM185.13,28.52l.81-2.25.37-1.02.39,1.09.78,2.18h-2.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "197.56 22.86 197.56 28.1 193.64 22.86 191.8 22.86 191.8 26.97 191.8 32.27 194 32.27 194 27.35 194 27.02 194.29 27.41 197.92 32.27 199.76 32.27 199.76 28.71 199.76 22.86 197.56 22.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "115.42 27.01 118.87 22.86 116.42 22.86 113.57 26.23 112.96 26.94 112.96 25.96 112.96 22.86 110.75 22.86 110.75 24.85 110.75 32.27 112.96 32.27 112.96 29.9 113.95 28.74 116.49 32.27 119.07 32.27 115.4 27.04 115.42 27.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "169.87 26.43 169.87 22.86 167.64 22.86 167.64 26.67 167.64 32.27 174 32.27 174 30.28 169.87 30.28 169.87 26.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M181.03,27.92c-.31-.38-.67-.65-1.09-.83-.42-.17-.96-.34-1.62-.5-.6-.14-1.03-.28-1.3-.42-.09-.05-.17-.1-.23-.16-.12-.12-.18-.27-.18-.46,0-.27.12-.49.35-.66.23-.17.6-.25,1.1-.25.79,0,1.58.24,2.37.73l.66-1.87c-.4-.27-.86-.47-1.39-.61-.52-.14-1.07-.21-1.63-.21-.8,0-1.48.13-2.03.4-.55.26-.97.62-1.24,1.08-.28.46-.42.97-.42,1.53,0,.14,0,.28.02.41.05.46.2.83.44,1.13.31.38.67.66,1.08.83.41.17.95.35,1.62.52.6.14,1.03.29,1.31.42.28.14.42.35.42.63,0,.26-.12.47-.36.62-.24.15-.62.23-1.13.23s-.98-.08-1.48-.25c-.5-.17-.94-.4-1.32-.69l-.74,1.85c.39.31.91.57,1.55.76.64.19,1.29.29,1.97.29.8,0,1.48-.13,2.04-.4.56-.27.98-.63,1.26-1.08.28-.45.42-.96.42-1.51,0-.64-.15-1.14-.46-1.52Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M81.23,40.95h-1.19l-.86-3.14-.89,3.14h-1.19l-1.37-4.94h1.15l.89,3.29.93-3.29h1.02l.9,3.32.92-3.32h1.05l-1.37,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M83.23,40.77c-.28-.17-.49-.4-.65-.7-.16-.3-.23-.64-.23-1.02s.08-.72.23-1.02c.16-.3.37-.53.65-.7.28-.17.59-.25.94-.25s.66.08.94.25c.28.17.49.4.65.7.16.3.23.64.23,1.02s-.08.71-.23,1.02c-.16.3-.37.53-.65.7-.28.17-.59.25-.94.25s-.67-.08-.94-.25ZM84.71,39.74c.14-.17.21-.4.21-.69s-.07-.53-.21-.7c-.14-.17-.32-.26-.54-.26s-.39.09-.53.26c-.14.17-.21.41-.21.7s.07.52.21.69c.14.17.32.26.53.26s.39-.09.53-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M88.55,37.07v1.14c-.13,0-.21-.01-.24-.01-.25,0-.45.08-.6.24-.14.16-.22.41-.22.74v1.76h-1.07v-3.82h1.02v.44c.24-.34.61-.51,1.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M90.01,35.72v5.23h-1.07v-5.23h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M94.08,40.95h-1.02v-.35c-.23.27-.55.41-.95.41-.31,0-.59-.08-.84-.24-.25-.16-.45-.39-.59-.69-.14-.3-.22-.64-.22-1.04s.07-.74.22-1.04c.14-.3.34-.53.59-.69.25-.16.53-.24.84-.24.38,0,.68.12.91.37v-1.73h1.06v5.23ZM92.83,39.74c.14-.17.21-.4.21-.69s-.07-.53-.21-.7c-.14-.17-.32-.26-.53-.26s-.4.09-.54.26c-.14.17-.21.41-.21.7s.07.52.21.69c.14.17.32.26.54.26s.39-.09.53-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M95.6,37.06v-1.04h3.74v1.04h-1.31v3.89h-1.1v-3.89h-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M101.47,37.07v1.14c-.13,0-.21-.01-.24-.01-.25,0-.45.08-.6.24-.14.16-.22.41-.22.74v1.76h-1.07v-3.82h1.02v.44c.24-.34.61-.51,1.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M104.43,37.51c.28.29.42.73.42,1.32v2.13h-1v-.43c-.17.33-.5.49-.96.49-.25,0-.47-.05-.65-.15-.18-.1-.33-.24-.43-.42-.1-.18-.15-.38-.15-.6,0-.36.12-.65.35-.85.23-.2.6-.31,1.09-.31h.68c0-.17-.03-.3-.09-.4-.14-.15-.35-.23-.62-.23-.16,0-.33.03-.49.09-.16.06-.3.14-.42.24l-.37-.87c.18-.14.39-.25.65-.33s.51-.12.78-.12c.52,0,.93.14,1.21.43ZM103.54,40.08c.11-.08.19-.19.24-.34v-.33h-.56c-.35,0-.52.13-.52.39,0,.12.04.22.12.29.08.07.19.11.33.11s.27-.04.38-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.89,40.95h-1.02v-.35c-.23.27-.55.41-.95.41-.31,0-.59-.08-.84-.24-.25-.16-.45-.39-.59-.69-.14-.3-.22-.64-.22-1.04s.07-.74.22-1.04c.14-.3.34-.53.59-.69.25-.16.53-.24.84-.24.38,0,.68.12.91.37v-1.73h1.06v5.23ZM107.64,39.74c.14-.17.21-.4.21-.69s-.07-.53-.21-.7c-.14-.17-.32-.26-.53-.26s-.4.09-.54.26c-.14.17-.21.41-.21.7s.07.52.21.69c.14.17.32.26.54.26s.39-.09.53-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M109.62,36.48c-.12-.13-.18-.29-.18-.48s.06-.35.18-.48c.12-.13.28-.19.47-.19s.35.06.47.18c.12.12.18.28.18.47,0,.21-.06.38-.18.5-.12.13-.28.19-.47.19s-.35-.06-.47-.19ZM110.62,37.14v3.82h-1.07v-3.82h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M113.13,40.96c-.14.04-.28.06-.44.06-.41,0-.72-.12-.94-.36-.22-.24-.33-.6-.33-1.07v-1.4h-.48v-.95h.48v-.95h1.07v.95h.77v.95h-.77v1.38c0,.15.03.27.1.35.06.08.15.12.27.12.14,0,.26-.04.36-.13l.28.87c-.1.08-.21.14-.35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M113.89,36.48c-.12-.13-.18-.29-.18-.48s.06-.35.18-.48.28-.19.47-.19.35.06.47.18c.12.12.18.28.18.47,0,.21-.06.38-.18.5-.12.13-.28.19-.47.19s-.35-.06-.47-.19ZM114.89,37.14v3.82h-1.07v-3.82h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M116.22,40.77c-.28-.17-.49-.4-.65-.7-.16-.3-.23-.64-.23-1.02s.08-.72.23-1.02c.16-.3.37-.53.65-.7.28-.17.59-.25.94-.25s.66.08.94.25c.28.17.49.4.65.7.16.3.23.64.23,1.02s-.08.71-.23,1.02c-.16.3-.37.53-.65.7-.28.17-.59.25-.94.25s-.67-.08-.94-.25ZM117.7,39.74c.14-.17.21-.4.21-.69s-.07-.53-.21-.7c-.14-.17-.32-.26-.54-.26s-.39.09-.53.26c-.14.17-.21.41-.21.7s.07.52.21.69c.14.17.32.26.53.26s.39-.09.53-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M122.48,37.5c.25.28.37.71.37,1.27v2.18h-1.06v-1.98c0-.55-.2-.82-.59-.82-.21,0-.37.08-.5.24-.13.16-.19.39-.19.71v1.86h-1.07v-3.82h1.02v.37c.13-.14.28-.25.46-.32.18-.08.37-.11.58-.11.41,0,.73.14.98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M125.95,37.51c.28.29.42.73.42,1.32v2.13h-1v-.43c-.17.33-.5.49-.97.49-.25,0-.47-.05-.65-.15-.18-.1-.33-.24-.43-.42-.1-.18-.15-.38-.15-.6,0-.36.12-.65.35-.85.23-.2.6-.31,1.09-.31h.68c0-.17-.03-.3-.09-.4-.14-.15-.35-.23-.62-.23-.16,0-.33.03-.49.09-.16.06-.3.14-.42.24l-.37-.87c.18-.14.39-.25.65-.33.25-.08.51-.12.78-.12.52,0,.93.14,1.21.43ZM125.06,40.08c.11-.08.19-.19.24-.34v-.33h-.56c-.35,0-.52.13-.52.39,0,.12.04.22.12.29.08.07.19.11.33.11s.27-.04.38-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M127.95,35.72v5.23h-1.07v-5.23h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M130.85,39.96l-.34.99h-1.13l1.87-4.94h1.09l1.87,4.94h-1.16l-.34-.99h-1.87ZM131.78,37.27l-.58,1.71h1.17l-.58-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M136.49,37.07v1.14c-.13,0-.21-.01-.24-.01-.25,0-.45.08-.6.24-.14.16-.22.41-.22.74v1.76h-1.07v-3.82h1.02v.44c.24-.34.61-.51,1.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M137.56,40.77c-.28-.17-.5-.4-.66-.7-.16-.3-.23-.64-.23-1.02s.08-.72.23-1.02c.16-.3.38-.53.66-.7.28-.17.6-.25.96-.25s.68.09.94.27c.26.18.45.43.57.75l-.83.51c-.15-.34-.38-.51-.69-.51-.22,0-.4.09-.54.26-.14.17-.21.41-.21.7s.07.53.21.7c.14.17.32.25.54.25.31,0,.54-.17.69-.51l.83.51c-.11.32-.3.57-.57.75-.26.18-.58.27-.94.27s-.67-.08-.96-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M143.41,37.5c.25.28.37.71.37,1.27v2.18h-1.06v-1.98c0-.55-.2-.82-.59-.82-.21,0-.38.08-.51.24-.13.16-.19.39-.19.71v1.86h-1.07v-5.23h1.07v1.73c.13-.13.28-.22.44-.29.17-.06.35-.1.55-.1.41,0,.73.14.98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M147.68,39.4h-2.4c.05.2.14.35.29.46.15.11.33.17.56.17.16,0,.3-.03.42-.08s.24-.14.35-.26l.56.71c-.31.41-.76.61-1.36.61-.38,0-.71-.08-1-.25-.29-.17-.51-.4-.67-.7-.16-.3-.23-.64-.23-1.01s.08-.71.23-1.02c.15-.3.37-.54.64-.71.27-.17.57-.25.91-.25s.62.08.88.24c.26.16.47.39.62.69.15.3.23.66.23,1.06l-.02.33ZM145.51,38.19c-.13.12-.21.29-.24.5h1.43c-.03-.21-.11-.38-.24-.5-.12-.12-.28-.18-.47-.18s-.35.06-.48.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M150.26,37.07v1.14c-.13,0-.21-.01-.24-.01-.25,0-.45.08-.6.24s-.22.41-.22.74v1.76h-1.07v-3.82h1.02v.44c.24-.34.61-.51,1.1-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.24,42.11c-.23.19-.51.28-.84.28-.17,0-.34-.03-.51-.1s-.31-.15-.41-.25l.37-.88c.07.07.15.13.25.17.1.04.2.06.29.06.08,0,.14,0,.18-.02.05-.01.09-.05.14-.11.05-.06.09-.15.14-.27l-1.41-3.85h1.1l.84,2.44.85-2.44h1.02l-1.44,4c-.16.46-.35.78-.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M156.64,40.72c-.35-.22-.63-.52-.83-.91-.2-.39-.3-.83-.3-1.32s.1-.93.3-1.32c.2-.39.48-.69.83-.91.35-.22.74-.33,1.18-.33.38,0,.72.08,1.02.23.3.16.56.38.76.68l-.71.76c-.28-.39-.61-.58-1.02-.58-.24,0-.46.06-.64.18-.19.12-.34.3-.44.52-.11.22-.16.48-.16.77s.05.54.16.77c.11.22.25.4.44.52.19.12.4.18.64.18.41,0,.75-.2,1.02-.59l.71.76c-.2.3-.46.52-.76.68-.3.16-.65.24-1.03.24-.44,0-.83-.11-1.18-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M163.01,37.5c.25.28.37.71.37,1.27v2.18h-1.06v-1.98c0-.55-.2-.82-.59-.82-.21,0-.38.08-.51.24-.13.16-.19.39-.19.71v1.86h-1.07v-5.23h1.07v1.73c.13-.13.28-.22.44-.29.17-.06.35-.1.55-.1.41,0,.73.14.98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M166.59,37.51c.28.29.42.73.42,1.32v2.13h-1v-.43c-.17.33-.5.49-.96.49-.25,0-.47-.05-.65-.15-.18-.1-.33-.24-.43-.42-.1-.18-.15-.38-.15-.6,0-.36.12-.65.35-.85.23-.2.6-.31,1.09-.31h.68c0-.17-.03-.3-.09-.4-.14-.15-.35-.23-.62-.23-.17,0-.33.03-.49.09-.16.06-.3.14-.42.24l-.37-.87c.18-.14.39-.25.65-.33.25-.08.51-.12.78-.12.52,0,.93.14,1.21.43ZM165.71,40.08c.11-.08.19-.19.24-.34v-.33h-.56c-.35,0-.52.13-.52.39,0,.12.04.22.12.29.08.07.19.11.33.11s.27-.04.38-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.71,37.5c.24.28.37.71.37,1.27v2.18h-1.07v-1.98c0-.28-.05-.48-.14-.62-.1-.14-.23-.2-.4-.2-.19,0-.35.07-.46.23-.11.15-.17.38-.17.69v1.89h-1.06v-1.98c0-.55-.18-.82-.55-.82-.19,0-.34.07-.45.23-.11.15-.17.38-.17.69v1.89h-1.07v-3.82h1.02v.37c.12-.14.27-.25.43-.32.17-.07.35-.11.55-.11.22,0,.41.05.6.14.18.09.33.23.45.42.14-.18.31-.32.51-.42.2-.1.41-.15.64-.15.41,0,.74.14.98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M176.54,37.32c.25.16.44.39.58.69.14.3.21.64.21,1.04s-.07.74-.21,1.04c-.14.3-.34.53-.58.69-.25.16-.52.24-.83.24-.39,0-.69-.12-.92-.37v1.68h-1.07v-5.18h1.02v.35c.23-.27.55-.41.97-.41.3,0,.58.08.83.24ZM176.05,39.74c.14-.17.21-.41.21-.7s-.07-.52-.21-.69c-.14-.17-.31-.26-.53-.26s-.39.09-.53.26c-.14.17-.21.4-.21.69s.07.53.21.7c.14.17.32.26.54.26s.39-.09.53-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M177.85,36.48c-.12-.13-.18-.29-.18-.48s.06-.35.18-.48.28-.19.47-.19.35.06.47.18c.12.12.18.28.18.47,0,.21-.06.38-.18.5-.12.13-.28.19-.47.19s-.35-.06-.47-.19ZM178.85,37.14v3.82h-1.07v-3.82h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M180.18,40.77c-.28-.17-.49-.4-.65-.7-.16-.3-.23-.64-.23-1.02s.08-.72.23-1.02c.16-.3.37-.53.65-.7.28-.17.59-.25.94-.25s.66.08.94.25c.28.17.49.4.65.7.16.3.23.64.23,1.02s-.08.71-.23,1.02c-.16.3-.37.53-.65.7-.28.17-.59.25-.94.25s-.67-.08-.94-.25ZM181.65,39.74c.14-.17.21-.4.21-.69s-.07-.53-.21-.7c-.14-.17-.32-.26-.54-.26s-.39.09-.53.26c-.14.17-.21.41-.21.7s.07.52.21.69c.14.17.32.26.53.26s.39-.09.53-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M186.43,37.5c.25.28.37.71.37,1.27v2.18h-1.06v-1.98c0-.55-.2-.82-.59-.82-.21,0-.37.08-.5.24-.13.16-.19.39-.19.71v1.86h-1.07v-3.82h1.02v.37c.13-.14.28-.25.46-.32.18-.08.37-.11.58-.11.41,0,.73.14.98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M187.82,40.9c-.26-.07-.47-.17-.63-.28l.34-.89c.15.11.33.19.54.26.21.06.4.1.59.1.35,0,.53-.09.53-.28,0-.09-.05-.15-.14-.19-.1-.04-.25-.07-.46-.1-.27-.04-.5-.09-.67-.16-.18-.06-.33-.17-.46-.33-.13-.16-.2-.39-.2-.68,0-.25.06-.47.19-.66.13-.19.31-.34.54-.45.23-.11.51-.16.83-.16.23,0,.46.03.69.09.23.06.43.14.59.24l-.36.88c-.28-.18-.59-.28-.93-.28-.19,0-.32.03-.42.08-.09.05-.14.12-.14.21,0,.09.05.16.15.2.1.04.26.08.48.12.27.05.49.1.67.16.17.06.32.17.45.33.13.16.19.38.19.67,0,.24-.06.46-.19.65-.13.19-.31.33-.55.44-.24.11-.52.16-.85.16-.27,0-.53-.04-.79-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M193.64,37.5c.25.28.37.71.37,1.27v2.18h-1.06v-1.98c0-.55-.2-.82-.59-.82-.21,0-.38.08-.51.24-.13.16-.19.39-.19.71v1.86h-1.07v-5.23h1.07v1.73c.13-.13.28-.22.44-.29.17-.06.35-.1.55-.1.41,0,.73.14.98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M194.72,36.48c-.12-.13-.18-.29-.18-.48s.06-.35.18-.48c.12-.13.28-.19.47-.19s.35.06.47.18c.12.12.18.28.18.47,0,.21-.06.38-.18.5-.12.13-.28.19-.47.19s-.35-.06-.47-.19ZM195.72,37.14v3.82h-1.07v-3.82h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M199.2,37.32c.25.16.44.39.58.69.14.3.21.64.21,1.04s-.07.74-.21,1.04c-.14.3-.34.53-.58.69-.25.16-.52.24-.83.24-.39,0-.69-.12-.92-.37v1.68h-1.07v-5.18h1.02v.35c.23-.27.55-.41.97-.41.3,0,.58.08.83.24ZM198.71,39.74c.14-.17.21-.41.21-.7s-.07-.52-.21-.69c-.14-.17-.31-.26-.53-.26s-.39.09-.53.26c-.14.17-.21.4-.21.69s.07.53.21.7c.14.17.32.26.54.26s.39-.09.53-.26Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngLogo);
export default __webpack_public_path__ + "static/media/eng_logo.0b09854c7626f5b6e4d3ec338fb2e408.svg";
export { ForwardRef as ReactComponent };